// extracted by mini-css-extract-plugin
export default {"vector":"PromoBanner-module__vector__fmj9T","text":"PromoBanner-module__text__RVmx1","banner":"PromoBanner-module__banner__jU_Gn"};